<template>
  <div class="page-deliver-edit">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">珠海倉庫</div>
      <div class="breadcrumb-item">待/已出庫訊息</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>

      <div class="pg-form-wrap">
        <Row>
          <Col span="11">
            <Form :label-width="150">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>重量</span>
                </div>
                <Input v-model="form.weight"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>快遞單號</span>
                </div>
                <Input
                  v-model="form.odd_numbers"
                  @on-blur="getOdd"
                  @keyup.enter.native="getOdd"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <!-- <em class="red">* </em> -->
                  <span>袋號</span>
                </div>
                <Input v-model="form.sack_number"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>澳門手機號/會員號</span>
                </div>
                <Input
                  v-model="form.recipient_phone"
                  @on-blur="getPickAddressByPhone"
                ></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>尺寸</span>
                </div>
                <Select placeholder="請選擇" v-model="form.size">
                  <Option :value="0">默認</Option>
                  <Option :value="1">厚度小於5cm</Option>
                  <Option :value="2">厚度大於5cm</Option>
                </Select>
              </FormItem>

              <div>
                <FormItem v-if="form.size != 0">
                  <div slot="label" class="form-label">
                    <em class="red">* </em>
                    <span>最長邊</span>
                  </div>
                  <Input v-model="form.long" @on-blur="getPickByLong"></Input>
                </FormItem>
                <FormItem v-else>
                  <div slot="label" class="form-label">
                    <em class="red">* </em>
                    <span>長X寬X高</span>
                  </div>
                  <div style="overflow: hidden">
                    <Row :gutter="16">
                      <Col span="8">
                        <Input
                          placeholder="長(CM)"
                          v-model="form.long"
                          ref="long_id"
                          @on-blur="getPickByLong"
                          @keyup.enter.native="onTab1"
                        ></Input>
                      </Col>
                      <Col span="8">
                        <Input
                          placeholder="寬(CM)"
                          v-model="form.wide"
                          ref="wide_id"
                          @on-blur="getPickByWide"
                          @keyup.enter.native="onTab2"
                        ></Input>
                      </Col>
                      <Col span="8">
                        <Input
                          placeholder="高(CM)"
                          v-model="form.height"
                          ref="height_id"
                          @on-blur="getPickByHeight"
                          @keyup.enter.native="onTab3"
                        ></Input>
                      </Col>
                    </Row>
                  </div>
                </FormItem>
              </div>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>快件明細</span>
                </div>
                <Select
                  ref="select"
                  placeholder="請選擇"
                  loading-text="加載中"
                  not-found-text="無匹配數據"
                  filterable
                  :loading="isLoadingDeliver"
                  @on-query-change="handleQueryChange"
                  v-model="form.detailed"
                  clearable
                >
                  <Option
                    :value="item.id"
                    :label="item.name"
                    v-for="(item, index) in deliverList"
                    :key="item.id"
                  >
                    {{ item.number }} {{ item.name }} {{ item.pinyin }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>指令錄入</span>
                </div>
                <Input
                  v-model="form.instructions"
                  @keyup.enter.native="onSubmit"
                ></Input>
              </FormItem>

              <FormItem>
                <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handleCheckForm">
                    確定并重新打印
                  </div>
                  <div class="pg-btn" @click="handleBack">返回</div>
                </div>
              </FormItem>

              <FormItem>
                <div class="form-tip-text">
                  <p style="color: black">
                    指令說明：<br />
                    客戶代碼：4-5位<br />
                    手機號查找：以+開始<br />
                    長寬高：以*開始<br />
                    破損代碼：6位<br />
                    面單代碼：7位到30位<br />
                    重量：含有小數點（.）<br />
                    尺寸：-開頭，（-1；-2；-3）<br />
                    快件明细：/開頭（/快件）<br />
                  </p>
                  <p style="color: red">打印條碼：Ctrl + s</p>
                </div>
              </FormItem>
            </Form>
          </Col>

          <Col span="11" offset="2">
            <Form :label-width="150">
              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>客戶名稱</span>
                </div>
                <Input v-model="form.recipient_contacts"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <em class="red">* </em>
                  <span>提貨櫃點</span>
                </div>

                <!-- <Select placeholder="請選擇" filterable not-found-text="無匹配數據" v-model="form.arrive">
                    <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                            :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                    </Option>
                </Select> -->

                <Select
                  placeholder="請選擇門店"
                  not-found-text="無匹配數據"
                  v-model="form.arrive"
                  @on-change="handleArriveSelect"
                  style="width: 49%"
                >
                  <Option
                    :value="item.ReceivingID"
                    v-for="(item, index) in pickAddress"
                    :key="item.ReceivingID"
                    >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
                </Select>

                <Select
                  placeholder="請選擇智能櫃"
                  not-found-text="無匹配數據"
                  v-model="form.arrive_cabinet"
                  @on-change="handleArriveSelectCabinet"
                  style="width: 49%; margin-left: 5px"
                >
                  <Option
                    :value="item.ReceivingID"
                    v-for="(item, index) in pickAddress_cabinet"
                    :key="item.ReceivingID"
                    >({{ item.cainiao_match }}) {{ item.ReceivingName }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>收件方式</span>
                </div>
                <Select
                  placeholder="請選擇"
                  v-model="form.arrive_type"
                  disabled
                >
                  <Option :value="1">門店</Option>
                  <Option :value="2">智能櫃</Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>異常件</span>
                </div>
                <Select placeholder="請選擇" v-model="form.abnormal_id">
                  <Option :value="0">無</Option>
                  <Option
                    :value="item.id"
                    v-for="(item, index) in deliverExc"
                    :key="item.id"
                    :disabled="item.id == 2 || item.title == '食品附加費'"
                  >
                    {{ item.title }}
                  </Option>
                </Select>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>珠海到付運費*1.3</span>
                </div>
                <Input v-model="form.freight_collect"></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>數量</span>
                </div>
                <InputNumber :min="1" v-model="form.count"></InputNumber>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>违禁品</span>
                </div>
                <Input v-model="form.contraband" clearable></Input>
              </FormItem>

              <FormItem>
                <div slot="label" class="form-label">
                  <span>违禁品百分比%</span>
                </div>
                <Input v-model="form.contraband_percentage" clearable></Input>
              </FormItem>
            </Form>

            <div
              style="
                font-size: 120px;
                color: #ff9a65;
                font-family: Arial;
                text-align: left;
              "
            >
              <div>${{ counterSum }}</div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    <div id="aaa" style="display: none">
      <div style="width: 290px; height: 200px; border: 1px solid #333">
        <div style="display: flex; border-bottom: 1px solid #333">
          <img
            style="width: 70px; height: 30px"
            src="https://jyb-admin-backend.aoyunltd.com/storage/logo/logo.png"
            alt=""
          />
          <div
            style="
              font-size: 12px;
              display: flex;
              align-items: center;
              flex-wrap: nowrap;
              font-weight: bold;
              margin-left: 7px;
            "
          >
            認領件認領件認領件認領件認領件
          </div>
        </div>
        <div style="display: flex; border-bottom: 1px solid #333">
          <div
            style="
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 60px;
              padding: 2px 4px;
              font-size: 18px;
              font-weight: bold;
              border-right: 1px solid #333;
            "
          >
            YT6817865342800
          </div>

          <div
            style="
              display: flex;
              width: 100px;
              flex-direction: column;
              justify-content: center;
              font-size: 10px;
              font-weight: bold;
            "
          >
            <div style="overflow: hidden">5917集運幫認領件</div>
            <div style="margin: 0px; padding: 0px; text-align: left">62086</div>
          </div>
        </div>
        <div style="display: flex; border-bottom: 1px solid #333">
          <div
            style="
              font-size: 50px;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              border-right: 1px solid #333;
              font-weight: bold;
              text-align: center;
            "
          >
            62086
          </div>
          <div style="width: 100px; padding: 4px 0; text-align: center">
            <img
              style="height: 80px; width: 80px"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA/AQMAAABtkYKcAAAABlBMVEX///8AAABVwtN+AAAAAXRSTlMAQObYZgAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAMZJREFUKJGF0E0Kg0AMBeBAF+70CF5E6LV0Ywvew7PoBTrHcBvIpoVhXpNJwU5taVYfvpH8EBC5OSPRV0gwMHWydFTvEHQSOtwM1PwGfQL4A22RLq9eDh0DKOY5Qosb8nJg1Qg8ZqwlAuRhkFDxsL0DAF8gidIQFdPtDfodFnFTyb3ifoc20kjHOAV7/AGPtGQhrnfYXmt0tGukEjrkPOaDh2rud+TLI42Gk/5eovW9Mq5UwFYbHdsBFmkLHqJf3pEvjykd8QR1NVqrX4Nz/QAAAABJRU5ErkJggg=="
              alt=""
            />
          </div>
        </div>
        <div style="font-size: 12px; margin-left: 4px">
          日期 :2022年10月19日
        </div>
      </div>
    </div>

    <!--    <PrintInCode ref="print_box"/>-->
    <!-- <PrintInCode4 ref="print_box" /> -->
    <!-- 新纸张缩小 新面单3 -->
    <PrintInCode5 ref="print_box" />
  </div>
</template>

<script>
import PrintInCode from "../../../components/PrintInCode";
import PrintInCode4 from "../../../components/PrintInCode4";
import PrintInCode5 from "../../../components/PrintInCode5";

export default {
  components: {
    PrintInCode,
    PrintInCode4,
    PrintInCode5,
  },
  data() {
    return {
      pageParam: {},
      isLoadingDeliver: false,
      localdetailList: [],
      deliverList: [], //快件明細
      pickAddress: [], //門店
      pickAddress_cabinet: [], //智能櫃
      packageType: [], //包裹類型
      deliverExc: [], //異常件
      err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
      suc_audio:
        "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",
      form: {
        amount: 0,
        weight: "", //重量單位g
        sack_number: "",
        odd_numbers: "", //單號
        recipient_phone: "", //澳門手機號
        long: "", //長
        wide: "", //寬
        height: "", //高
        size: "", //尺寸，1: 最長邊大於50cm; 2: 小於5cm
        detailed: "", //快件明細id
        instructions: "", //指令
        recipient_contacts: "", //澳門客戶名稱
        arrive: "", //門店
        arrive_cabinet: "", //智能櫃
        // goods_type: '',  //包裹類型id
        arrive_type: "", //收件方式: 1門店，2:智能櫃
        abnormal_id: "", //異常id
        freight_collect: "", //珠海到付運費
        count: 1, //數量
        contraband: "", // 违禁品
        contraband_percentage: "", // 违禁品百分百
      },
      isSubmiting: false,
      counterSum: 0,
      print_box: null,
    };
  },
  mounted() {
    this.pageParam = this.$route.query;
    this.getDeliverList();
    this.getPackageType();
    this.getPickAddress();
    this.getPickAddress_cabinet();
    this.getDeliverExc();
    this.getDetail();
    // document.onkeydown = this.keydonwFn
    document.addEventListener("keydown", this.keydonwFn);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keydonwFn);
  },
  watch: {
    "form.long": function (val, oldVal) {
      if (val != 0) {
        this.conunterPrice();
      }
    },
    "form.wide": function (val, oldVal) {
      if (val != 0) {
        this.conunterPrice();
      }
    },
    "form.height": function (val, oldVal) {
      if (val != 0) {
        this.conunterPrice();
      }
    },
    "form.weight": function (val, oldVal) {
      if (val != 0) {
        this.conunterPrice();
      }
    },
    "form.size": function (val, oldVal) {
      this.conunterPrice();
    },
    "form.abnormal_id": function (val, oldVal) {
      this.conunterPrice();
    },
    "form.freight_collect": function (val, oldVal) {
      this.conunterPrice();
    },
    /* "form.detailed": function (val, oldVal) {
      if (val === 6066 || val === 7241) this.form.abnormal_id = 2;
      else this.form.abnormal_id = 0;
    }, */
  },
  methods: {
    keydonwFn(event) {
      if (event.ctrlKey && event.keyCode === 83) {
        this.handleCheckForm();
      }
    },
    conunterPrice() {
      let { form } = this.$data;
      let data = {
        long: form.long,
        wide: form.wide,
        height: form.height,
        weight: form.weight,
        size: form.size,
        abnormal_id: form.abnormal_id,
        freight_collect: form.freight_collect,
      };
      if (data.size == 0) {
        this.counterSum = 0;
        if (data.long && data.wide && data.height && data.weight) {
          this.setCounter(data);
        }
      } else if (data.size == 1 || data.size == 2) {
        if (data.long && data.weight) {
          this.setCounter(data);
        }
      }
    },
    setCounter(data) {
      if (data.abnormal_id == 0) {
        data.abnormal_id = "";
      }
      this.$Rq
        .requestAuth({
          method: "post",
          url: this.$Api.counterSums,
          data,
        })
        .then((res) => {
          this.counterSum = res.data.amount || 0;
        })
        .catch((err) => {
          this.counterSum = 0;
        });
    },
    getOdd() {
      if (this.odd_numbers == "") {
        return false;
      }
      this.getItem();
    },
    getItem() {
      this.$Rq
        .requestAuth({
          url: this.$Api.scanIn,
          method: "get",
          data: {
            sack_number: this.form.odd_numbers,
            odd_numbers: this.form.odd_numbers,
          },
        })
        .then((res) => {
          if (res.data.count == 1 && res.data.data[0].id != this.pageParam.id) {
            this.$Utils.showTipInfo("該單號已存在");
            let audio = new Audio();
            audio.src = this.err_audio;
            audio.play();
          }
        });
    },
    handleBack() {
      this.$router.go(-1);
    },
    onSubmit() {
      // +手机号
      if (this.form.instructions.charAt(0) == "+") {
        this.form.recipient_phone = this.form.instructions.substr(1);
        this.form.instructions = "";
        this.getPickAddressByPhone();
        return false;
      }

      // .重量
      if (this.form.instructions.indexOf(".") != -1) {
        if (this.form.instructions.charAt(0) == ".") {
          this.form.weight = this.form.instructions.substr(1);
        } else {
          this.form.weight = this.form.instructions;
        }
        this.form.instructions = "";
        return false;
      }
      // *长宽高
      if (this.form.instructions.charAt(0) == "*") {
        if (!this.form.long) {
          this.form.long = this.form.instructions.substr(1);
          this.form.instructions = "";
          return false;
        } else {
          if (this.form.size == 0) {
            if (!this.form.wide) {
              this.form.wide = this.form.instructions.substr(1);
              this.form.instructions = "";
              return false;
            } else {
              if (!this.form.height) {
                this.form.height = this.form.instructions.substr(1);
                this.form.instructions = "";
                return false;
              }
            }
          } else {
            this.form.long = this.form.instructions.substr(1);
            this.form.instructions = "";
            return false;
          }
        }
      }
      // 客户代码 4-5
      if (
        this.form.instructions.length <= 6 &&
        this.form.instructions.length >= 4 &&
        this.form.instructions.charAt(0) != "/" &&
        this.form.instructions.charAt(0) != "-" &&
        this.form.instructions.charAt(0) != "." &&
        this.form.instructions.charAt(0) != "*"
      ) {
        this.form.recipient_phone = this.form.instructions.substr(0);
        this.form.instructions = "";
        this.getPickAddressByPhone();
        return false;
      }
      // 快递单号
      if (
        this.form.instructions.length > 6 &&
        this.form.instructions.length < 31
      ) {
        this.form.odd_numbers = this.form.instructions;
        this.getOdd();
        this.form.instructions = "";
        return false;
      }
      // 快件类型 -1 默认 -2厚度小于5 -3厚度大于5
      if (this.form.instructions.charAt(0) == "-") {
        if (this.form.instructions == "-1") {
          this.form.size = 0;
          this.form.long = "";
          this.form.wide = "";
          this.form.height = "";
        } else if (this.form.instructions == "-2") {
          this.form.size = 1;
          this.form.wide = "";
          this.form.height = "";
        } else if (this.form.instructions == "-3") {
          this.form.size = 2;
          this.form.wide = "";
          this.form.height = "";
        }
        this.form.instructions = "";
      }

      // /xx搜索商品详情
      if (this.form.instructions.charAt(0) == "/") {
        let value = this.form.instructions.substr(1);
        // this.handleSearchDeliver(value);
        this.handleSearchDeliverLocalSession(value);
        setTimeout(() => {
          this.$refs.select.visible = true;
          this.$refs.select.isFocused = true;
        }, 500);
        this.form.instructions = "";
      }
    },
    //快件明細
    getDeliverList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverList,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            let resData = res.data.data;
            this.deliverListAll = resData;
            this.deliverList = resData;
            this.localdetailList = resData;
            sessionStorage.setItem(
              "jyb_detailed",
              JSON.stringify(this.localdetailList)
            );
          }
        });
    },
    //包裹類型
    getPackageType() {
      this.$Rq
        .requestAuth({
          url: this.$Api.packageType,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.packageType = res.data.data;
          }
        });
    },
    //門店
    getPickAddress() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
            type: 1,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data.filter(
              (it) => it.company_id != 15
            );
          }
        });
    },
    //智能櫃
    getPickAddress_cabinet() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
            type: 2,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress_cabinet = res.data.data.filter(
              (it) => it.company_id != 15
            );
          }
        });
    },
    //異常件
    getDeliverExc() {
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverExc,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            this.deliverExc = res.data.data;
          }
        });
    },
    //根據手機號獲取提貨櫃點,以及客戶名稱
    getPickAddressByPhone() {
      let form = this.form;
      if (form.recipient_phone !== "") {
        this.$Rq
          .requestAuth({
            url: this.$Api.getInfoByPhone + "/" + form.recipient_phone,
            method: "get",
          })
          .then((res) => {
            let store_type =
              res.data.receiving == null ? "" : res.data.receiving.Type;
            if (res.code == 0) {
              if (res.code.data) {
                this.$Utils.showTipInfo("用戶不存在");
                // return false;
              }
              if (store_type == 1) {
                let resData = res.data || {};
                this.form.recipient_contacts = resData.user_id
                  ? resData.user_name
                  : "";
                this.form.recipient_phone = resData.user_id
                  ? resData.phone
                  : ""; // 會員號碼 match 電話號碼
                this.form.arrive = resData.receiving
                  ? resData.receiving.ReceivingID
                  : "";
                this.form.arrive_cabinet = "";
                this.form.arrive_type = resData.receiving
                  ? resData.receiving.Type
                  : "";
              } else if (store_type == 2) {
                let resData = res.data || {};
                this.form.recipient_contacts = resData.user_id
                  ? resData.user_name
                  : "";
                this.form.recipient_phone = resData.user_id
                  ? resData.phone
                  : ""; // 會員號碼 match 電話號碼
                this.form.arrive = "";
                this.form.arrive_cabinet = resData.receiving
                  ? resData.receiving.ReceivingID
                  : "";
                this.form.arrive_type = resData.receiving
                  ? resData.receiving.Type
                  : "";
              } else if (store_type == undefined) {
                let resData = res.data || {};
                this.form.recipient_contacts = resData.user_id
                  ? resData.user_name
                  : "";
                this.form.recipient_phone = resData.user_id
                  ? resData.phone
                  : ""; // 會員號碼 match 電話號碼
                this.form.arrive = resData.receiving
                  ? resData.receiving.ReceivingID
                  : "";
                this.form.arrive_cabinet = resData.receiving
                  ? resData.receiving.ReceivingID
                  : "";
                this.form.arrive_type = resData.receiving
                  ? resData.receiving.Type
                  : "";
              } else {
                this.form.recipient_contacts = "";
                this.form.recipient_phone = "";
                this.form.arrive = "";
                this.form.arrive_cabinet = "";
                this.form.arrive_type = "";
              }
            }
          });
      } else {
        this.form.recipient_contacts = "";
        this.form.arrive = "";
      }
    },

    //門店選擇
    handleArriveSelect(value) {
      if (
        value == undefined &&
        this.form.arrive == undefined &&
        (this.form.arrive_cabinet != undefined ||
          this.form.arrive_cabinet != "" ||
          this.form.arrive_cabinet != null)
      ) {
        return;
      }

      if (
        value == undefined &&
        this.form.arrive == undefined &&
        this.form.arrive_cabinet == undefined
      ) {
        return;
      }

      let pickAddress = this.pickAddress;
      let index = null;
      for (let i = 0; i < pickAddress.length; i++) {
        if (value == pickAddress[i].ReceivingID) {
          index = i;
          break;
        }
      }
      this.form.arrive = value;
      this.form.arrive_type = pickAddress[index].Type; //Type 1門店, 2智能櫃
      this.form.arrive_cabinet = "";
    },

    //智能櫃選擇
    handleArriveSelectCabinet(value) {
      if (
        value == undefined &&
        this.form.arrive_cabinet == undefined &&
        (this.form.arrive != undefined ||
          this.form.arrive != "" ||
          this.form.arrive != null)
      ) {
        return;
      }

      if (
        value == undefined &&
        this.form.arrive_cabinet == undefined &&
        this.form.arrive == undefined
      ) {
        return;
      }

      let pickAddress = this.pickAddress_cabinet;
      let index = null;
      for (let i = 0; i < pickAddress.length; i++) {
        if (value == pickAddress[i].ReceivingID) {
          index = i;
          break;
        }
      }
      this.form.arrive_cabinet = value;
      this.form.arrive_type = pickAddress[index].Type; //Type 1門店, 2智能櫃
      this.form.arrive = "";
    },
    handleQueryChange(value) {
      if (value === "") {
        this.deliverList = this.deliverListAll;
      }
    },
    // handleSearchDeliver(value) {
    //     this.isLoadingDeliver = true;
    //     this.deliverList = [];
    //     this.$Rq.requestAuth({
    //         url: this.$Api.deliverList,
    //         method: 'get',
    //         data: {
    //             /* offset: 0,
    //              limit: 200,*/
    //             keywords: value
    //         }
    //     }).then((res) => {
    //         if (res.code == 0) {
    //             this.isLoadingDeliver = false;
    //             this.$nextTick(() => {

    //             });
    //             this.deliverList = res.data.data;
    //         }
    //     }).catch((err) => {
    //         this.isLoadingDeliver = false;
    //     });
    // },
    //快件下拉搜索LocalSession
    handleSearchDeliverLocalSession(value) {
      let deliverListdetail = JSON.parse(
        sessionStorage.getItem("jyb_detailed")
      );
      this.isLoadingDeliver = true;
      let queryData = deliverListdetail.filter((item) => {
        return (
          item.name.indexOf(value) > -1 ||
          (item.number && item.number.toString().indexOf(value) > -1) ||
          item.pinyin.toLowerCase().indexOf(value.toLowerCase()) > -1
        );
      });
      this.$nextTick(() => {
        this.deliverList = queryData;
      });
      this.isLoadingDeliver = false;
    },
    getDetail() {
      this.$Rq
        .requestAuth({
          url: this.$Api.deliverDetail + "/" + this.pageParam.id,
          method: "get",
        })
        .then((res) => {
          if (res.code == 0) {
            let resData = res.data;
            let shop_arrive_type = Number(resData.arrive_type);
            let shop_arrive = "";
            let cabinet_arrive = "";

            if (shop_arrive_type == 1) {
              shop_arrive = resData.arrive;
            } else if (shop_arrive_type == 2) {
              cabinet_arrive = resData.arrive;
            } else {
              shop_arrive = "";
              cabinet_arrive = "";
            }

            this.form = {
              amount: resData.amount,
              weight: resData.weight,
              sack_number: resData.sack_number,
              odd_numbers: resData.odd_numbers,
              recipient_phone: resData.recipient_phone,
              long: resData.long,
              wide: resData.wide,
              height: resData.height,
              size: resData.size,
              detailed: resData.detailed.id,
              instructions: resData.instructions,
              recipient_contacts: resData.recipient_contacts,
              arrive: shop_arrive,
              arrive_cabinet: cabinet_arrive,
              // goods_type: resData.goods_type,
              arrive_type: shop_arrive_type,
              abnormal_id: resData.abnormal_id,
              freight_collect: Math.round(resData.freight_collect / 1.3), // Math.round(resData.freight_collect / 1.3)
              count: resData.count,
            };
          }
        });
    },
    //提交
    handleCheckForm() {
      let form = this.form;
      if (form.weight === "") {
        this.$Utils.showTipInfo("請輸入重量");
        return;
      }
      if (form.odd_numbers === "") {
        this.$Utils.showTipInfo("請輸入快遞單號");
        return;
      }
      if (form.recipient_phone === "") {
        this.$Utils.showTipInfo("請輸入澳門手機號/會員號");
        return;
      }
      // if (form.size === "") {
      //   this.$Utils.showTipInfo("請選擇尺寸");
      //   return;
      // }
      //校驗長寬高
      // if (!this.handleCheckLength()) {
      //   return;
      // }
      // if (form.detailed === "") {
      //   this.$Utils.showTipInfo("請選擇快件明細");
      //   return;
      // }
      if (form.recipient_contacts === "") {
        this.$Utils.showTipInfo("請輸入客戶名稱");
        return;
      }
      if (form.arrive == "" && form.arrive_cabinet == "") {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == null && form.arrive_cabinet == null) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == undefined && form.arrive_cabinet == undefined) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      /*else if (form.arrive_type === '')
      {
          this.$Utils.showTipInfo('請選擇收件方式');
          return;
      }*/
      this.handleSubmit();
    },
    handleCheckLength() {
      let form = this.form;
      let long = Number(form.long);
      let wide = Number(form.wide);
      let height = Number(form.height);
      let arr = [long, wide, height];
      let max = Math.max(...arr);
      let min = Math.min(...arr);

      if (form.size == 1) {
        if (form.long === "") {
          this.$Utils.showTipInfo("請輸入最长边");
          return false;
        }

        if (!(form.long > 1 && form.long < 50)) {
          this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
          return false;
        }
      }
      if (form.size == 0) {
        if (form.long === "") {
          this.$Utils.showTipInfo("請輸入长");
          return false;
        }
        if (form.wide === "") {
          this.$Utils.showTipInfo("請輸入宽");
          return false;
        }
        if (form.height === "") {
          this.$Utils.showTipInfo("請輸入高");
          return false;
        }

        if (max <= 50) {
          this.$Utils.showTipInfo("最長邊应大於50cm");
          return false;
        }
      }
      if (form.size == 2) {
        if (form.long === "") {
          this.$Utils.showTipInfo("請輸入最长边");
          return false;
        }

        if (!(form.long >= 1 && form.long <= 50)) {
          this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
          return false;
        }
      }
      if (form.size == 4) {
        if (form.long === "") {
          this.$Utils.showTipInfo("請輸入长");
          return false;
        }
        if (form.wide === "") {
          this.$Utils.showTipInfo("請輸入宽");
          return false;
        }
        if (form.height === "") {
          this.$Utils.showTipInfo("請輸入高");
          return false;
        }

        if (min <= 5) {
          this.$Utils.showTipInfo("厚度應大於5cm");
          return false;
        }
        if (!(max >= 1 && max <= 50)) {
          this.$Utils.showTipInfo("尺寸不符合最長邊尺寸");
          return false;
        }
      }
      return true;
    },

    //根據长度识别异常件
    getPickByLong() {
      let long = this.form.long;
      if (this.form.size != 0) {
        if (long > 50) {
          this.$Utils.showTipInfo("最长边輸入不合法");
        }
      }
      if (long > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }
    },
    getPickByWide() {
      let wide = this.form.wide;
      if (this.form.size != 0) {
        if (wide > 50) {
          this.$Utils.showTipInfo("最长边輸入不合法");
        }
      }
      if (wide > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }
    },
    getPickByHeight() {
      let height = this.form.height;
      if (this.form.size != 0) {
        if (height > 50) {
          this.$Utils.showTipInfo("最长边輸入不合法");
        }
      }
      if (height > 40 && this.form.arrive_type == 2) {
        this.form.abnormal_id = 1;
      } else {
        this.form.abnormal_id = 0;
      }
    },
    async print_war() {
      const form = this.form;
      let shop_arrive = form.arrive;
      if (
        shop_arrive == null ||
        shop_arrive == "" ||
        shop_arrive == undefined
      ) {
        shop_arrive = form.arrive_cabinet;
      }
      this.$refs.print_box.printCode(
        {
          order: form.odd_numbers,
          user_phone: form.recipient_phone,
          store_id: shop_arrive,
        },
        (res) => {
          res == "yes"
            ? this.$Message.success("打印成功")
            : this.$Message.error("打印失败");
        }
      );
    },
    handlePrintCode() {
      let form = this.form;
      if (form.weight === "") {
        this.$Utils.showTipInfo("請輸入重量");
        return;
      }
      if (form.odd_numbers === "") {
        this.$Utils.showTipInfo("請輸入快遞單號");
        return;
      }
      // if (form.size === "") {
      //   this.$Utils.showTipInfo("請選擇尺寸");
      //   return;
      // }

      //校验长宽高
      // if (!this.handleCheckLength()) {
      //   return;
      // }
      if (form.arrive == "" && form.arrive_cabinet == "") {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == null && form.arrive_cabinet == null) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.arrive == undefined && form.arrive_cabinet == undefined) {
        this.$Utils.showTipInfo("請選擇提貨櫃點");
        return;
      }
      if (form.count === "") {
        this.$Utils.showTipInfo("請選擇數量");
        return;
      }
      // if (form.detailed === "") {
      //   this.$Utils.showTipInfo("請選擇快件明細");
      //   return;
      // }

      this.print_war();
      return;

      let shop_arrive = form.arrive;
      if (
        shop_arrive == null ||
        shop_arrive == "" ||
        shop_arrive == undefined
      ) {
        shop_arrive = form.arrive_cabinet;
      }

      let token = localStorage.getItem("jyb_token");
      let params = {
        //Authorization: token,
        print_update: 1,
        odd_numbers: form.odd_numbers,
        arrive: shop_arrive,
        amount: form.amount,
        weight: form.weight,
        size: form.size,
        long: Number(form.long),
        wide: Number(form.wide),
        height: Number(form.height),
        tel: form.recipient_phone,
        arrive_type: form.arrive_type,
        abnormal_id: form.abnormal_id ? Number(form.abnormal_id) : 0,
        freight_collect: Math.round(form.freight_collect * 1.3),
        //time: new Date().getTime()
      };
      // this.pdfUrl = this.$Api.deliverCode + '?' + this.$Utils.formateObjToParamStr(params);
      // window.open(this.pdfUrl);

      this.$Rq
        .requestAuth({
          url: this.$Api.deliverCode2,
          method: "get",
          data: params,
          headers: {
            responseType: "blob",
          },
        })
        .then((res) => {
          // console.dir(res)

          /*const LODOP = getLodop();
        LODOP.PRINT_INIT("dsahdsadshajdhsjoahi");
        LODOP.SET_PRINT_PAGESIZE(1,800,600,"")
        let aaa = document.getElementById('aaa')
        LODOP.ADD_PRINT_HTM(6, 5, '100%', '100%', aaa.innerHTML);
        LODOP.PRINT();*/

          let blob = new Blob([res], { type: "text/html;charset=utf-8" });
          let urlPdf = window.URL.createObjectURL(blob);
          let newWindow = window.open(urlPdf);
          if (window.print) {
            newWindow.print();
          }
          newWindow.addEventListener("afterprint", function () {
            newWindow.document.close();
            window.URL.revokeObjectURL(urlPdf);
            newWindow.close();
          });
        });
    },
    handleSubmit() {
      let form = this.form;
      this.isSubmiting = true;
      let shop_arrive = form.arrive;
      if (
        shop_arrive == null ||
        shop_arrive == "" ||
        shop_arrive == undefined
      ) {
        shop_arrive = form.arrive_cabinet;
      }

      this.$Rq
        .requestAuth({
          url: this.$Api.deliverUpdate + "/" + this.pageParam.id,
          method: "post",
          data: {
            weight: Number(form.weight),
            sack_number: form.sack_number,
            odd_numbers: form.odd_numbers,
            recipient_phone: form.recipient_phone,
            long: Number(form.long),
            wide: Number(form.wide),
            height: Number(form.height),
            size: Number(form.size),
            detailed: Number(form.detailed),
            instructions: form.instructions,
            recipient_contacts: form.recipient_contacts,
            arrive: shop_arrive,
            // goods_type: Number(form.goods_type),
            arrive_type: Number(form.arrive_type),
            abnormal_id: Number(form.abnormal_id),
            freight_collect: Math.round(form.freight_collect),
            count: Number(form.count),
            contraband: Number(form.contraband),
            contraband_percentage: Number(form.contraband_percentage),
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            this.$Utils.showSuccess(res.msg);
            this.handlePrintCode();
            return;
            // if(res.data.url) {
            // 	window.location.href = res.data.url
            // }
            /*this.form = {
              weight: '',  //重量單位g
              odd_numbers: '',  //單號
              recipient_phone: '',  //澳門手機號
              long: '',    //長
              wide: '',    //寬
              height: '',   //高
              size: '', //尺寸，1: 最長邊大於50cm; 2: 小於5cm
              detailed: '',    //快件明細id
              instructions: '',   //指令
              recipient_contacts: '',  //澳門客戶名稱
              arrive: '', //提貨櫃點
              goods_type: '',  //包裹類型id
              arrive_type: '',   //收件方式: 1門店，2:智能櫃
              abnormal_id: '', //異常id
              freight_collect: '', //珠海到付運費
              count: 1,   //數量
          };*/
          } else {
            this.$Utils.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "DeliverEdit.scss";
</style>
